import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgBingo = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.836 5.494c0-.967.784-1.75 1.75-1.75h10.397c.967 0 1.75.783 1.75 1.75v4.852a.75.75 0 0 1-1.5 0V5.494a.25.25 0 0 0-.25-.25H4.586a.25.25 0 0 0-.25.25v12.405c0 .138.112.25.25.25h4.018a.75.75 0 0 1 0 1.5H4.586a1.75 1.75 0 0 1-1.75-1.75zm14.426-.556a.75.75 0 0 1 .918-.53l1.496.4a1.75 1.75 0 0 1 1.237 2.144l-1.13 4.218a.75.75 0 1 1-1.45-.388l1.131-4.218a.25.25 0 0 0-.177-.306l-1.495-.401a.75.75 0 0 1-.53-.919m-4.073 11.913a3.53 3.53 0 1 1 7.06 0 3.53 3.53 0 0 1-7.06 0m3.53-5.03a5.03 5.03 0 1 0 0 10.06 5.03 5.03 0 0 0 0-10.06m1.806 3.348H15.33L15.33 16.3h1.375l-1.328 2.79h1.423zM7.154 7.82a.926.926 0 1 1-1.852 0 .926.926 0 0 1 1.852 0m0 3.876a.926.926 0 1 1-1.853 0 .926.926 0 0 1 1.853 0m0 3.876a.926.926 0 1 1-1.852 0 .926.926 0 0 1 1.852 0m3.532-7.752a.926.926 0 1 1-1.852 0 .926.926 0 0 1 1.852 0m0 3.876a.926.926 0 1 1-1.852 0 .926.926 0 0 1 1.852 0m0 3.876a.926.926 0 1 1-1.852 0 .926.926 0 0 1 1.852 0M14.22 7.82a.926.926 0 1 1-1.852 0 .926.926 0 0 1 1.852 0m-.226 3.58c-.492.27-.947.608-1.355 1.003a.93.93 0 0 1-.477-.81q.001-.185.068-.348l.005-.012a.93.93 0 0 1 .769-.562h.001l.083-.004a.92.92 0 0 1 .906.733"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgBingo;
